import React from "react";
import "./index.css";
import { useContextProvider } from "../../context";
import { useForm } from "@formspree/react";
import successIcon from "../../icons/ok.png";
import errorIcon from "../../icons/stop.png";
import { bookingDict } from "../../utilities";
import { trackEvent } from "../../utilities/tracking";
import { Spinner } from "../spinner";

export const ContactForm: React.FC = () => {
  const [state, handleSubmit, reset] = useForm("mlevebrn");
  const { language } = useContextProvider();

  const submittedSuccessfully = state.succeeded;
  const hasError = !!state.errors;

  const handleSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSubmit(e);
    trackEvent("contact_form_submitt", {
      event_category: "form",
      event_label: "contact_form",
    });
  };

  const form = (
    <form onSubmit={handleSubmitForm}>
      <div className="ContactForm-column">
        <label htmlFor="fullName">{bookingDict[language].fullName}</label>
        <input
          type="text"
          id="fullName"
          name="fullName"
          autoComplete="name"
          placeholder={bookingDict[language].fullNamePlaceholder}
          required
        />
      </div>
      <div className="ContactForm-column">
        <label htmlFor="email">{bookingDict[language].email}</label>
        <input
          type="email"
          id="email"
          name="email"
          autoComplete="email"
          placeholder={bookingDict[language].emailPlaceholder}
        />
      </div>
      <div className="ContactForm-column">
        <label htmlFor="phone">{bookingDict[language].phone}</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          autoComplete="tel"
          placeholder={bookingDict[language].phonePlaceholder}
          required
        />
      </div>
      <div className="ContactForm-column">
        <label htmlFor="message">{bookingDict[language].message}</label>
        <textarea
          id="message"
          name="message"
          placeholder={bookingDict[language].messagePlaceholder}
          required
        />
      </div>
      <div className="ContactForm-column">
        <label htmlFor="pickUpPlace">{bookingDict[language].pickUpPlace}</label>
        <input
          type="text"
          id="pickUpPlace"
          name="pickUpPlace"
          placeholder={bookingDict[language].pickUpPlacePlaceholder}
          required
        />
      </div>
      <div className="ContactForm-column">
        <label htmlFor="dropOffPlace">
          {bookingDict[language].dropOffPlace}
        </label>
        <input
          type="text"
          id="dropOffPlace"
          name="dropOffPlace"
          placeholder={bookingDict[language].dropOffPlacePlaceholder}
          required
        />
      </div>
      <div className="ContactForm-row">
        <div className="ContactForm-column">
          <label htmlFor="pickUpDate">{bookingDict[language].pickUpDate}</label>
          <input type="date" id="pickUpDate" name="pickUpDate" required />
        </div>
        <div className="ContactForm-column">
          <label htmlFor="pickUpTime">{bookingDict[language].pickUpTime}</label>
          <input
            type="time"
            id="pickUpTime"
            name="pickUpTime"
            defaultValue="12:00"
          />
        </div>
      </div>
      <div className="ContactForm-row">
        <div className="ContactForm-column">
          <label htmlFor="dropOffDate">
            {bookingDict[language].dropOffDate}
          </label>
          <input type="date" id="dropOffDate" name="dropOffDate" required />
        </div>
        <div className="ContactForm-column">
          <label htmlFor="dropOffTime">
            {bookingDict[language].dropOffTime}
          </label>
          <input
            type="time"
            id="dropOffTime"
            name="dropOffTime"
            defaultValue="12:00"
          />
        </div>
      </div>
      {state.submitting ? (
        <Spinner />
      ) : (
        <button
          className="ContactForm-button"
          type="submit"
          disabled={state.submitting}
        >
          {bookingDict[language].submit}
        </button>
      )}
    </form>
  );

  const error = (
    <>
      <div className="ContactForm-message">
        <img src={errorIcon} alt="Error Icon" />
        <p>
          <strong>{bookingDict[language].erorr.title}</strong>
        </p>
        <p>{bookingDict[language].erorr.text}</p>
      </div>
      <button className="ContactForm-button" type="button" onClick={reset}>
        {bookingDict[language].repeat}
      </button>
    </>
  );

  const success = (
    <>
      <div className="ContactForm-message">
        <img src={successIcon} alt="Success Icon" />
        <p>
          <strong>{bookingDict[language].success.title}</strong>
        </p>
        <p>{bookingDict[language].success.text}</p>
      </div>
      <button className="ContactForm-button" type="button" onClick={reset}>
        {bookingDict[language].repeat}
      </button>
    </>
  );

  return (
    <section className="ContactForm">
      <div className="ContactForm-container">
        <h2>{bookingDict[language].title}</h2>
        {hasError ? error : submittedSuccessfully ? success : form}
      </div>
    </section>
  );
};
